import React from 'react';
import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { TQuickAction } from '../../types';
import s from './s.module.less';

type Props = {
    actions: TQuickAction[];
};

const ArrowIcon = () => (
    <svg className={s.arrow} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" width="16" height="16">
        <line x1="4" y1="10" x2="16" y2="10" />
        <polyline points="11 5 16 10 11 15" />
    </svg>
);

const QuickActions: React.FC<Props> = ({ actions }) => {
    return (
        <div className={s.wrap}>
            <h2 className={s.title}>Quick Actions</h2>
            <div className={s.card}>
                {actions.map((action, i) => {
                    if (action.subItems) {
                        const menuItems: MenuProps['items'] = action.subItems.map((sub, idx) => ({
                            key: idx,
                            label: sub.label,
                            onClick: sub.action,
                        }));
                        return (
                            <Dropdown key={i} menu={{ items: menuItems }} trigger={['hover']} placement="bottomRight">
                                <div className={s.row}>
                                    <span className={s.label}>{action.label}</span>
                                    <ArrowIcon />
                                </div>
                            </Dropdown>
                        );
                    }
                    return (
                        <div key={i} className={s.row} onClick={action.action}>
                            <span className={s.label}>{action.label}</span>
                            <ArrowIcon />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default QuickActions;
